import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import styles from './index.module.scss';

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const languages = [
    { code: 'it', name: 'Italiano', flag: '🇮🇹' },
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'fr', name: 'Français', flag: '🇫🇷' },
  ];

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  const handleLanguageChange = async (languageCode) => {
    try {
      await i18n.changeLanguage(languageCode);
      dayjs.locale(languageCode);
      localStorage.setItem('i18nextLng', languageCode);
      setIsOpen(false);
    } catch (error) {
      console.error('Error changing language:', error);
    }
  };

  return (
    <div className={styles.languageSelector}>
      <div 
        className={styles.selector}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className={styles.flag}>{currentLanguage.flag}</span>
        <span className={styles.name}>{currentLanguage.name}</span>
        <span className={`${styles.arrow} ${isOpen ? styles.arrowOpen : ''}`}>▼</span>
      </div>
      
      {isOpen && (
        <div className={styles.dropdown}>
          {languages.map((language) => (
            <div
              key={language.code}
              className={`${styles.option} ${
                language.code === i18n.language ? styles.selected : ''
              }`}
              onClick={() => handleLanguageChange(language.code)}
            >
              <span className={styles.flag}>{language.flag}</span>
              <span className={styles.name}>{language.name}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
